import { Container } from '@mui/material';
import BenefitDetailsLoading from 'src/modules/benefits/components/benefit-details-loading';
import Page from 'src/components/page/page';
import CouponForm from './components/coupon-form';
import HeaderBreadcrumbs from 'src/components/header-bread-crumbs/HeaderBreadcrumbs';
import useLPCouponDetails from './coupon-lp-details.hook';
import RegisterCodes from 'src/modules/benefits/products/details/components/code-modal';
import RegisterCpfs from 'src/modules/benefits/products/details/components/cpf-modal';
import RedeemsModal from 'src/modules/benefits/products/details/components/redeem-modal';

export default function LPCouponDetails() {
  const hook = useLPCouponDetails();

  return (
    <Page title={hook.isEdit ? 'Editar Benefício' : 'Cadastrar Benefício'}>
      <Container maxWidth="xl">
        <HeaderBreadcrumbs
          heading={hook.isEdit ? 'Editar Benefício' : 'Cadastrar Benefício'}
          links={[]}
          sx={{ mb: 3 }}
        />
        {hook.isDetailsLoading ? <BenefitDetailsLoading /> : <CouponForm hook={hook} />}
        <RegisterCodes productDetailsHook={hook} />
        <RegisterCpfs productDetailsHook={hook} />
        <RedeemsModal productHook={hook} />
      </Container>
    </Page>
  );
}
